module.exports = __webpack_public_path__ + "img/movies-icon.20737395.svg";